import { createStyles, makeStyles } from '@mui/styles';
import { STYLE } from '../../../../constants';

export const useStyles = makeStyles(() =>
  createStyles({
    root: {
      display: 'inline-flex',
      alignItems: 'center',
      height: '22px',
      borderRadius: '4px',
      padding: '0 8px',
      fontSize: '10px',
      fontWeight: 600,
      textTransform: 'uppercase',
      fontFamily: STYLE.FONT.PRIMARY_FONT,
      whiteSpace: 'nowrap',
    },
    green: {
      backgroundColor: STYLE.COLOR.SUCCESS_BACKGROUND,
      color: STYLE.COLOR.SUCCESS,
    },
    yellow: {
      backgroundColor: STYLE.COLOR.PENDING,
      color: STYLE.COLOR.WARNING,
    },
    red: {
      backgroundColor: STYLE.COLOR.ERROR_LIGHTER,
      color: STYLE.COLOR.ERROR,
    },
    gray: {
      backgroundColor: STYLE.COLOR.ICONS3,
      color: STYLE.COLOR.WHITE,
    },
  }),
);
